const API_BASE_URL= "#{API_BASE_URL}#";
const domain ="#{domain}#"
const audience = "#{audience}#";
const clientId = "#{clientId}#";
const scope = "openid profile email";

//const API_BASE_URL= "https://localhost:44331/api/v3/";
// const API_BASE_URL= "https://clarraqaapi.azurewebsites.net/api/v3/";
// // //const domain  = "clarra-qa.us.auth0.com";
// const domain  = "loginqa.clarra.com";
// const audience = "https://clarraqa/external/api";
// const clientId = "4XEcTDvBRWpYUoLjDdREO3IycFqFlhvq";
// const scope = "openid profile email";

// //Productionv
// const API_BASE_URL= "https://api.clarra.com/";
// const domain  = "clarra.us.auth0.com";
// const audience = "https://clarra/externalauth/api";
// const clientId = "AoVqaBxROMTWQHVkRxL8UpHFdc6eW8XI";
// const scope = "openid profile email";


//const API_BASE_URL= "https://localhost:44331/";
// const domain  ="loginstaging.clarra.com"; // "clarra-qa.us.auth0.com";
// //staging 
// const API_BASE_URL= "https://clarrastagingapi.azurewebsites.net/api/v2/";
// const domain ="clarra-staging.us.auth0.com"
// const audience = "https://clarrastaging/external/api";
// const clientId = "b20pBTH7jvMwqDqM6YBbIaoJnJ4hvb3p";
// const scope = "openid profile email";

// Auth0 client used by the BROWSER-side login path (auth0-react /
// loginWithPopup - new Outlook, Outlook on the web, Mac). Auth0 only issues
// a refresh token to a browser-originated authorization-code exchange when
// the application is type "Single Page Application" AND Refresh Token
// Rotation is enabled; otherwise it logs "The scope 'offline_access' was
// requested, but no 'refresh_token' was issued because the authorization
// code exchange originated from a browser" and useRefreshTokens has nothing
// to work with. The classic-Outlook path is exempt: it exchanges the code
// server-side via the Public API (AuthSession/session), so it is not
// browser-originated. If one Auth0 app cannot satisfy both, point this at a
// dedicated SPA app. Defaults to clientId, so behaviour is unchanged until set.
const spaClientId = clientId;

const GetAllMatter= "Matter/Outlook/GetAllMatterList/";
const ActivityTypes = "Utilities/ActivityTypes";
const GetServiceTypes = "Utilities/GetServiceTypes";
const GetTags = "Utilities/GetTags";
const TaskType = "Utilities/TaskType";
const GetTimeSlipSettings = "TimeSlip/GetTimeSlipSettings";
const CreateCommunicationsform = "Communications/Outlook/Createform";
const UploadURL = "Communications/Upload/Initiate";
const CreateTimeslip = "TimeSlip/Outlook/CreateNewTimeSlip";
const CreateClarraDocs = "ClarraDocs/Create";
const CreateClarraDocsform ="ClarraDocs/Outlook/Create";
const CreateClarraDocsBody = "ClarraDocs/Create/zapierbody";
const GetPermission= "Communications/GetPermission";
const GetCommunicationByExternalId  = "Communications/Outlook/GetDetailExternal";
const GetStatus  = "Communications/Outlook/GetSyncStatus";
const SetKey  = "Utilities/SetKey";
const GetKey  = "Utilities/GetKey";
const DeleteKey = "Utilities/DeleteKey";
const GlobalProperties ="Schema/GlobalProperties"; 
const GraphMicrosoftBaseURL = "https://graph.microsoft.com/v1.0/me/messages/";
const Attachments="/attachments/";
const UploadIniate="Communications/Upload/Initiate";
const value="/$value"
const Page="0";
const Size="2500";
const IngnoreFileExtensions = "exe,bat,cmd,sh,php,pl,cgi,386,dll,com,torrent,js,app,jar,vb,vbs,asp,aspx,cer,cfm,csr,css,htm,html,jsp,php,rss,xhtml,docm,xlsm,pptm,bak,cab,cfg,cpl,cur,dat,dmp,drv,icns,ico,ini,lnk,msi,sys,tmp,7z,arj,deb,pkg,rar,rpm,tar,gz,z,zip,svg,tiff,m4a,m4v,mpg,mpeg,wm,db,dbf,mdb,sql,pdb,sqlitedb,sqlite3,asc,cer,crt,der";
export {
    API_BASE_URL,
    domain,
    audience,
    scope,
    clientId,
    spaClientId,
    GetAllMatter,
    ActivityTypes,
    GetServiceTypes,
    GetTags,
    TaskType,
    CreateTimeslip,
    CreateClarraDocs,
    Page,
    Size,
    GetPermission,
    CreateCommunicationsform,
    CreateClarraDocsform,
    CreateClarraDocsBody,
    GetCommunicationByExternalId,
    GetTimeSlipSettings,
    GetStatus,
    SetKey,
    GetKey,
    DeleteKey,
    GlobalProperties,
    GraphMicrosoftBaseURL,
    Attachments,
    value,
    UploadIniate,
    UploadURL,
    IngnoreFileExtensions
  };